import { supabase } from "@/integrations/supabase/client";

export type NotifyEvent =
  | "New Author Signup"
  | "New Book Uploaded"
  | "Placement Request"
  | "Author Reply"
  | "New Contact Message"
  | "New Live Chat"
  | "New Testimonial";

export async function notifyTelegram(event: NotifyEvent, message: string) {
  try {
    await supabase.functions.invoke("notify-telegram", {
      body: { event, message },
    });
  } catch (e) {
    // best-effort
    console.warn("notifyTelegram failed", e);
  }
}
